"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function () {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Aba = exports.Abas = void 0;
var lodash_1 = require("lodash");
var react_1 = __importStar(require("react"));
var tema_1 = require("../../tema");
var Styles = __importStar(require("./Abas.styles"));
var classnames_1 = __importDefault(require("classnames"));
function Aba(_a) {
  var children = _a.children;
  return children;
}
exports.Aba = Aba;
function Abas(_a) {
  var children = _a.children,
    sxDoTitulo = _a.sxDoTitulo;
  var abas = lodash_1.isArray(children) ? children : [children];
  var titulos = abas.map(function (aba) {
    return aba.props.label;
  });
  var _b = react_1.useState(0),
    indiceDoAtivo = _b[0],
    definirAtivo = _b[1];
  return react_1.default.createElement(tema_1.Tema, null, react_1.default.createElement(Styles.Container, null, react_1.default.createElement(Styles.ContainerDeTitulos, null, titulos.map(function (titulo, indice) {
    return react_1.default.createElement(Styles.Titulo, {
      key: indice,
      className: classnames_1.default({
        ativo: indiceDoAtivo === indice
      }),
      onClick: function () {
        return definirAtivo(indice);
      },
      sx: sxDoTitulo
    }, titulo);
  })), abas[indiceDoAtivo]));
}
exports.Abas = Abas;